import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import CommentsApp from "./components/CommentsApp";
import TNCSearchApp from "./components/TNCSearchApp";
import MonitorApp from "./components/MonitorApp";
import DefaultPage from "./components/DefaultPage";
import HomePage from "./components/HomePage";
//import registerServiceWorker from "./registerServiceWorker";

var root_el = document.getElementById("root");
if (/^\/tnc[\/]?$/i.test(window.location.pathname)) {
  ReactDOM.render(<TNCSearchApp />, root_el);
} else if (/^\/comments[\/]?$/i.test(window.location.pathname)) {
  ReactDOM.render(<CommentsApp />, root_el);
} else if (/^\/monitor[\/]?$/i.test(window.location.pathname)) {
  ReactDOM.render(<MonitorApp />, root_el);
} else if (/^\/$/i.test(window.location.pathname)) {
  // Root path shows default page
  ReactDOM.render(<DefaultPage />, root_el);
} else {
  // Unknown routes show default page (like default-page.html)
  ReactDOM.render(<DefaultPage />, root_el);
}
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js